import { render, staticRenderFns } from "./AuctionListTabs.vue?vue&type=template&id=68434605&scoped=true&"
import script from "./AuctionListTabs.vue?vue&type=script&lang=js&"
export * from "./AuctionListTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68434605",
  null
  
)

export default component.exports